import { IAttribute, IModel, LinkedService, Metamodel, kafkaAuthTypes } from 'shell-models-lib';
import { adfModelTypeMap } from '../../registries/consts/adf-model-type-map-const';
import { format } from '../../shared/utils/string.util';

@Metamodel.model({
    name: adfModelTypeMap.kafka.linkedServiceType,
    display: [
        format(stringResources.ModelName_LinkedServiceTemplate, stringResources.Kafka_DisplayText),
        format(stringResources.ModelName_LinkedServicesTemplate, stringResources.Kafka_DisplayText)
    ]
})
export class KafkaLinkedService extends LinkedService {
    public static readonly MODEL: IModel;

    public static BOOTSTRAPSERVERS: IAttribute;
    public static SASLMECHANISM: IAttribute;
    public static USER_NAME: IAttribute;
    public static PASSWORD: IAttribute;

    @Metamodel.attribute({
        display: stringResources.ModelName_bootstrapServers,
        templatable: true,
        association: 'BOOTSTRAPSERVERS'
    })
    public bootstrapServers: string;

    @Metamodel.attribute({
        display: stringResources.ModelName_AuthenticationType
    })
    public authenticationType: kafkaAuthTypes;

    @Metamodel.attribute({
        display: stringResources.ModelName_UserName,
        templatable: true,
        association: 'USER_NAME'
    })
    public username: string;

    @Metamodel.attribute({
        display: stringResources.ModelName_Password,
        templatable: true,
        association: 'PASSWORD'
    })
    public password: string;

    @Metamodel.attribute({
        display: stringResources.SASLMechanism_DisplayName,
        templatable: true,
        association: 'SASLMECHANISM'
    })
    public saslMechanism: string;
    constructor(name?: string, description?: string) {
        super(name, description);
    }
}
